import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { Tabs } from 'projects/access-control/src/app/Domain/Entities/tabs.interface';
import { ToastAlert } from 'projects/access-control/src/app/Infrastructure/hooks/toast.hook';
import { updateModuleOneClient } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.action';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { COMMA, ENTER, SPACE, FF_SEMICOLON } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { CodeJarContainer } from 'ngx-codejar';
import hljs from 'highlight.js';

interface translateViewSelectedClients {
	buttonEdit: string;
	buttonSave: string;
	textName: string;
	textSystem: string;
	textHost: string;
	textNotSelected: string;
	errorToastConfig: string;
	textCode: string;
	customDomain: string;
	mainHost: string;
	mainHostPlaceholder: string;
}
@Component({
	selector: 'app-view-selected-clients',
	templateUrl: './view-selected-clients.component.html',
	styleUrls: ['./view-selected-clients.component.scss'],
})
export class ViewSelectedClientsComponent implements OnInit, OnChanges {
	@Input() client: Client = {} as Client;
	@Input() isModuleSelected = false;
	@Input() module: ModuleClient = {} as ModuleClient;
	@Input() loading: boolean = false;
	separatorExp: string = ',';
	viewSelect: string = '1';
	isEditModule = true;
	name = '';
	mainHost = '';
	subscriptionTranslate!: Subscription;
	theme = 'vs';
	css: string = '';
	frontend: string = '';
	backend: string = '';
	isDragActive = false;
	code = '';
	dataTranslate: translateViewSelectedClients = {} as translateViewSelectedClients;
	options = {
		contextmenu: true,
		minimap: {
			enabled: false,
		},
	};
	tabs: Tabs[] = [
		{
			label: 'General',
			value: '1',
		},
		{
			label: 'CSS',
			value: '2',
		},
		{
			label: 'Frontend',
			value: '3',
		},
		{
			label: 'Backend',
			value: '4',
		},
		// {
		// 	label: 'Deploy',
		// 	value: '5',
		// },
	];
	valueHost: string[] = [];
	fileUrl: string = '';
	selectable = true;
	removable = true;
	addOnBlur = true;
	urlOptional = '';
	readonly separatorKeysCodes = [ENTER, COMMA, FF_SEMICOLON, SPACE] as const;
	constructor(
		private store: Store,
		private translateService: TranslateService,
		private toastAlert: ToastAlert
	) {}

	ngOnInit(): void {
		this.getTranslate();
	}

	add(event: MatChipInputEvent): void {
		const value = (event.value || '').trim();
		const addItem = this.valueHost.find((item) => item === value);
		if (value && !addItem) {
			this.valueHost = this.valueHost.length > 0 ? [...this.valueHost, value] : [value];
			this.urlOptional = '';
		}
		event.chipInput!.clear();
	}
	enterHost(event: any) {
		const { value } = event.target;
		this.urlOptional = value;
	}

	remove(host: string): void {
		const index = this.valueHost.indexOf(host);
		if (index >= 0) {
			this.valueHost.splice(index, 1);
		}
	}

	highlightMethodCss(editor: CodeJarContainer) {
		if (editor.textContent !== null && editor.textContent !== undefined) {
			editor.innerHTML = hljs.highlight(editor.textContent, {
				language: 'css',
			}).value;
		}
	}

	highlightMethodJson(editor: CodeJarContainer) {
		if (editor.textContent !== null && editor.textContent !== undefined) {
			editor.innerHTML = hljs.highlight(editor.textContent, {
				language: 'json',
			}).value;
		}
	}

	tabSelect(event: any) {
		//Tab seleccionado
		this.viewSelect = event;
	}

	getTranslate() {
		//Se extrae los textos del translate para la vista de clientes.
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.dataTranslate = data.pages.clients.components.viewSelectedClients;
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.viewSelect = '1';
		this.isEditModule = true;
		this.backend = this.module?.backend || '{}';
		this.frontend = this.module?.frontend || '{}';
		this.css = this.module?.css || '';
		this.valueHost = this.module?.host && this.module?.host.length > 0 ? [...this.module.host] : [];
		this.name = this.module.custom_name_module || '';
		this.fileUrl = this.module.logo || '';
		this.mainHost = this.module?.mainUrl || '';
	}

	urlUploadedHandle(event: any) {
		this.fileUrl = event.url;
	}

	urlUploadedErrorHandle(event: any) {
		console.error(event);
	}

	public onDragOver() {
		this.isDragActive = true;
	}

	public onDragLeave(event: Event) {
		this.isDragActive = false;
	}
	focusChips(event: Event) {}

	editModule() {
		//La accion de editar el modulo
		if (this.isEditModule === true) {
			this.isEditModule = false;
		} else {
			try {
				const value = (this.urlOptional || '').trim();
				const addItem = this.valueHost.find((item) => item === value);
				if (value && !addItem) {
					this.valueHost.push(this.urlOptional);
				}
				this.frontend = this.frontend.length > 0 ? this.frontend : '{}';
				this.backend = this.backend.length > 0 ? this.backend : '{}';
				const validateFront = JSON.parse(this.frontend);
				const validateBack = JSON.parse(this.backend);
				const module: ModuleClient = {
					...this.module,
					css: this.css,
					frontend: this.frontend,
					backend: this.backend,
					custom_name_module: this.name,
					host: this.valueHost || [],
					pk: this.module.modulePk,
					sk: this.module.moduleSk,
					logo: this.fileUrl,
					isEdit: true,
					mainUrl: this.mainHost?.trim(),
				} as ModuleClient;
				const params: IPkSk = {
					pk: this.client.sk,
					sk: this.client.pk,
				} as IPkSk;
				this.store.dispatch(updateModuleOneClient({ module, params }));
				this.isEditModule = true;
			} catch (error) {
				if (error instanceof SyntaxError) {
					let message = error.message;
					this.toastAlert.toastFailure(this.dataTranslate.errorToastConfig, message);
				} else {
					throw error; // si es otro error, que lo siga lanzando
				}
			}
		}
	}
}
